import http from "@/plugins/Axios";
import { defineRulesForPermissions } from "@/configuration/ability";
import { ability } from "@/plugins/Casl";
import TokenService from "@/services/TokenService";
import { makerPagination } from "@/utils/pureFunctions";
import { USER_ROLES } from "@/utils/constants";

let refreshInterval = null;

export default {
  state: {
    /**
     * @type (null | {otherRoles: Array<{}>})
     */
    user: null,
    drawer: false,
    notificationCount: 0,
    isForbidden: false,
  },
  getters: {
    user: (state) => state.user,
    isForbidden: (state) => state.isForbidden,
    isNurse(state) {
      if (state.user) {
        if (state.user.roles.length === 2) {
          if (
            state.user.roles.includes(USER_ROLES.DEPARTMENT) &&
            state.user.roles.includes(USER_ROLES.OMTK)
          ) {
            return true;
          }
        }
      }
      return false;
    },
    permissions: (state) => {
      if (state.user && state.user.permissions) {
        return state.user.permissions;
      }
      return [];
    },
    roles: (state) => {
      if (state.user && state.user.roles) {
        return state.user.roles;
      }
      return [];
    },
    additionalRoles(state) {
      if (state.user && state.user.otherRoles) {
        return state.user.otherRoles;
      }
      return [];
    },
    isUserAdmin: (state) => {
      return !!(
        state.user &&
        state.user.roles &&
        state.user.roles.includes(USER_ROLES.ADMIN)
      );
    },
  },
  mutations: {
    clearTimerRefreshToken() {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    },
  },
  actions: {
    // runTimerRefreshToken({ dispatch, commit }) {
    //   let lastTime = 0;
    //   let offset = 1000;
    //   let time = localStorage.getItem("Expire");
    //   if (time) {
    //     lastTime = parseInt((+time - offset - new Date().getTime()) / 1000);
    //     commit("clearTimerRefreshToken");
    //     refreshInterval = setInterval(() => {
    //       lastTime--;
    //       if (lastTime < offset) {
    //         lastTime = 0;
    //         commit("clearTimerRefreshToken");
    //         dispatch("refreshToken");
    //       }
    //     }, 1000);
    //   }
    // },
    async refreshToken() {
      try {
        const {
          data: { sessionToken, refreshToken, expiresIn },
        } = await http.post("refresh-token", {
          refreshToken: TokenService.getRefreshToken(),
        });
        TokenService.setToken(sessionToken, expiresIn, refreshToken);
      } catch (e) {
        console.error(e);
      }
    },
    async getUsers(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("user/items", {
          params,
        });
        return {
          data,
          lastPage:
            query && query.limit
              ? makerPagination({ limit: query.limit, total }).lastPage
              : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getUserList(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("user/list", {
          params,
        });
        return {
          data,
          lastPage:
            query && query.limit
              ? makerPagination({ limit: query.limit, total }).lastPage
              : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getUser({ state }) {
      try {
        const {
          data: { data },
        } = await http.get("user/current");
        state.user = data;
        const /**
           * @type {Array}
           */
          rules = defineRulesForPermissions(data.permission);
        ability.update(rules);
      } catch (e) {
        if (e.response.status === 403) {
          state.isForbidden = true;
        }
        return Promise.reject(e);
      }
    },
  },
};
